module.exports = __webpack_public_path__ + "static/img/15.81ccf6f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/1/zh/15.png
// module id = 1gd/
// module chunks = 0